import { InjectionToken, Provider } from '@angular/core';
import { StytchSetup } from './stytch-setup.service';

export const StytchPublicToken = new InjectionToken<string>(
  'StytchPublicToken'
);
export const StytchBaseUrl = new InjectionToken('StytchBaseUrl');
export const StytchWhiteLabel = new InjectionToken('StytchWhiteLabel');

export function provideStytch(): Provider[] {
  return [
    {
      provide: StytchPublicToken,
      useFactory: (stytchSetup: StytchSetup) => stytchSetup.publicToken(),
      deps: [StytchSetup],
    },
    {
      provide: StytchBaseUrl,
      useFactory: (stytchSetup: StytchSetup) => stytchSetup.baseHost(),
      deps: [StytchSetup],
    },
    {
      provide: StytchWhiteLabel,
      useFactory: (stytchSetup: StytchSetup) => stytchSetup.whiteLabel(),
      deps: [StytchSetup],
    },
  ];
}
